<template>
  <div v-if="false">
    <p>Active Step: {{ activeStep }}</p>
    <p>Tabs To Show Length: {{ tabsToShow.length }}</p>
    <p>Is Last Step: {{ isLastActiveStep }}</p>
    <p>Order Total Price: {{ orderTotalPrice }}</p>
  </div>

  <div class="app-step-two__btns">
    <app-button
      :disabled="disabledPreviousButton"
      :loading="loading"
      outlined
      theme="accent"
      @click="emit('onPreviousButtonClick')"
      >Back</app-button
    >
    <app-button
      :disabled="disabledNextButton"
      :loading="loading"
      @click="emit('onNextButtonClick')"
    >
      {{ nextButtonText }}
    </app-button>
  </div>
</template>

<script setup>
import { useLoading } from '@core/composables/useLoading'
import { useOrder } from '@core/composables/order/useOrder'
import { computed } from 'vue'
import { useTabsStore } from '@/stores/tabs'
import { storeToRefs } from 'pinia'

import AppButton from '@modules/ui/app-button.vue'
import { useOrderStore } from '../../../../../stores/order'

const props = defineProps({
  disabledOuterCondition: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['onPreviousButtonClick', 'onNextButtonClick'])

const { nextTab, tabsToShow, isLastTab } = storeToRefs(useTabsStore())
const orderStore = useOrderStore()
const { activeStep } = useOrder()

const isInitialActiveStep = computed(() => activeStep.value === 0)
// Delegate to the store's clamp-safe isLastTab so an out-of-range activeStep
// still resolves to "Order Now" (and navigates to billing) rather than a dead
// "Next - undefined".
const isLastActiveStep = computed(() => isLastTab.value)
const disabledNextButtonGeneral = computed(
  () => props.disabledOuterCondition || props.loading
)

const disabledPreviousButton = computed(
  () => isInitialActiveStep.value || props.loading
)

const disabledNextButton = computed(() => disabledNextButtonGeneral.value)

const nextButtonText = computed(() => {
  return isLastActiveStep.value
    ? 'Next'
    : `Next - ${nextTab.value?.name ?? ''}`
})
</script>
